var React = require('react');

function BurgerInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.75 38.2523H47.25C48.4943 38.2523 49.5 39.2558 49.5 40.5C49.5 41.7397 48.4943 42.7523 47.25 42.7523H6.75C5.508 42.7523 4.5 41.7397 4.5 40.5C4.5 39.2558 5.508 38.2523 6.75 38.2523ZM47.25 15.7477H6.75C5.508 15.7477 4.5 14.742 4.5 13.5C4.5 12.2602 5.508 11.25 6.75 11.25H47.25C48.4943 11.25 49.5 12.2602 49.5 13.5C49.5 14.742 48.4943 15.7477 47.25 15.7477ZM47.25 29.2478H6.75C5.508 29.2478 4.5 28.2443 4.5 27C4.5 25.758 5.508 24.7478 6.75 24.7478H47.25C48.4943 24.7478 49.5 25.758 49.5 27C49.5 28.2443 48.4943 29.2478 47.25 29.2478Z","fill":"black"}));
}

BurgerInline.defaultProps = {"width":"54","height":"54","viewBox":"0 0 54 54","fill":"none"};

module.exports = BurgerInline;

BurgerInline.default = BurgerInline;
